declare global {
  interface Window {
    MapSvgOverlayFullsize: any;
    MapSvgOverlayPinned: any;
  }
}

export interface MapSvgOverlayPinnedOptions {
  element: HTMLElement;
  map: any;
  scale: number;
  x: number;
  y: number;
  bounds: google.maps.LatLngBounds;
}

export function defineTypes(): void {
  class SVGOverlayFullsize extends google.maps.OverlayView {
    bounds: google.maps.LatLngBounds;
    image: HTMLElement | null = null;

    constructor(bounds: google.maps.LatLngBounds, image: HTMLElement, map: google.maps.Map) {
      super();
      this.bounds = bounds;
      this.image = image;
      this.setMap(map);
    }

    onAdd(): void {
      // Create a container div for the SVG
      // this.div = document.createElement("div");
      if (this.image) {
        this.image.style.position = "absolute";
        this.image.style.pointerEvents = "auto";
      }

      // Insert the SVG content
      // this.div.innerHTML = this.svgContent;

      // Allow interaction with the SVG
      // this.div.style.pointerEvents = "auto";

      // Append the container div to the overlay pane
      const panes = this.getPanes();
      if (this.image && panes && panes.overlayLayer) {
        panes.overlayMouseTarget.appendChild(this.image);
      }
    }

    draw(): void {
      if (!this.image) return;

      // Get the projection to calculate pixel positions
      const overlayProjection = this.getProjection();
      if (!overlayProjection) return;

      const sw = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest());
      const ne = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast());

      if (sw && ne) {
        // Position and size the SVG container
        this.image.style.left = `${sw.x}px`;
        this.image.style.top = `${ne.y}px`;
        this.image.style.width = `${ne.x - sw.x}px`;
        this.image.style.height = `${sw.y - ne.y}px`;
      }
    }

    onRemove(): void {
      if (this.image) {
        this.image.parentNode?.removeChild(this.image);
        this.image = null;
      }
    }
  }

  class SVGOverlayPinned extends google.maps.OverlayView {
    bounds: google.maps.LatLngBounds;
    element: HTMLElement | null = null;
    scale: number;

    constructor(options: MapSvgOverlayPinnedOptions) {
      super();
      this.element = options.element;
      this.scale = options.scale;
      this.bounds = this.boundsWithOffset(options);
      this.setMap(options.map);
    }

    boundsWithOffset(options: MapSvgOverlayPinnedOptions): google.maps.LatLngBounds {
      const latOffset = parseFloat(`${options.x}`);
      const lonOffset = parseFloat(`${options.y}`);

      let sw = options.bounds.getSouthWest();
      let ne = options.bounds.getNorthEast();

      return new google.maps.LatLngBounds(
        new google.maps.LatLng(sw.lat() + lonOffset, sw.lng() + latOffset),
        new google.maps.LatLng(ne.lat() + lonOffset, ne.lng() + latOffset)
      );
    }

    onAdd(): void {
      if (this.element) {
        this.element.style.position = "absolute";
        this.element.style.pointerEvents = "auto";
      }
      const panes = this.getPanes();
      if (this.element && panes && panes.overlayLayer) {
        panes.overlayMouseTarget.appendChild(this.element);
      }
    }

    draw(): void {
      if (!this.element) return;
      const overlayProjection = this.getProjection();
      if (!overlayProjection) return;
      const swPx = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest());
      const nePx = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast());
      if (swPx && nePx) {
        //this.element.style.border = "2px dashed rgba(0, 0, 0, 0.2)";
        this.element.style.left = `${swPx.x}px`;
        this.element.style.top = `${nePx.y}px`;
        this.element.style.width = `${nePx.x - swPx.x}px`;
        this.element.style.height = `${swPx.y - nePx.y}px`;
        this.element.style.transform = `scale(${this.scale})`;
      }
    }

    onRemove(): void {
      if (this.element) {
        this.element.parentNode?.removeChild(this.element);
        this.element = null;
      }
    }
  }

  window.MapSvgOverlayFullsize = SVGOverlayFullsize;
  window.MapSvgOverlayPinned = SVGOverlayPinned;
}

export class OverlayHelper {
  static defineTypes(): void {
    if (!window.MapSvgOverlayFullsize || !window.MapSvgOverlayPinned) defineTypes();
  }

  static createFullsizeOverlay(
    bounds: google.maps.LatLngBounds,
    image: HTMLElement,
    map: google.maps.Map
  ): any {
    return new window.MapSvgOverlayFullsize(bounds, image, map);
  }

  static createPinnedOverlay(options: MapSvgOverlayPinnedOptions): any {
    return new window.MapSvgOverlayPinned(options);
  }
}
